/*
 * Meztli · Página de mayoreo. Lo cargan con defer mz-landing-hero, mz-landing-ejemplo y
 * mz-landing-cta; corre una sola vez aunque venga en varias secciones.
 *
 *  1. Código de campaña: ?c=CÓDIGO tal cual; si solo viene utm_campaign, se arma «MAY-SHOP-<campaña>» (el «codigo» del
 *     hero como prefijo) para no perder que llegó por esta página. Se limpia (sin acentos; letras, números, . _ -; máx. 40)
 *     y se guarda en sessionStorage para la visita. Sin código en la URL ni en la visita, usa el «codigo» del hero.
 *     Los utm_* de la visita también se pasan al formulario del ERP; el utm_source y el utm_medium que falten se
 *     completan con shopify y pagina-mayoreo. El ERP guarda c, utm_source y utm_medium en el registro de la Socia
 *     (SociaRegistro.codigo_campana / utm_source / utm_medium).
 *  2. Enlaces [data-mz-cta]:
 *       registro  → formulario (propio data-mz-url o el del hero) con c=CÓDIGO y los utm_*.
 *       whatsapp  → wa.me/<número>?text=<mensaje · CÓDIGO>. Sin número en ningún lado, el botón se queda oculto.
 *       kit       → WhatsApp con su data-mz-mensaje si hay número; si no, el formulario.
 *     La configuración del hero llega en <script type="application/json" data-mz-landing-config>.
 *  3. Barra fija de celular [data-mz-cta-fija]: visible cuando el hero ([data-mz-hero]) ya salió por arriba, y oculta
 *     mientras se ve el llamado final ([data-mz-cta-final]) o el pie (.footer).
 *  4. Aviso del live [data-mz-live-hasta="AAAA-MM-DD"]: se oculta al pasar ese día (fecha del navegador).
 */
(() => {
  if (window.MzLanding) return;
  window.MzLanding = true;

  const CLAVE = 'mz_codigo';
  const CLAVE_UTM = 'mz_utm';
  const UTM_OMISION = { utm_source: 'shopify', utm_medium: 'pagina-mayoreo' };
  let observadores = [];

  const limpiar = (valor) =>
    String(valor || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^A-Za-z0-9_.-]/g, '')
      .slice(0, 40);

  const leerConfig = () => {
    const el = document.querySelector('[data-mz-landing-config]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  };

  const leerCodigo = (porOmision) => {
    const q = new URLSearchParams(window.location.search);
    const campana = limpiar(q.get('utm_campaign'));
    const prefijo = limpiar(porOmision);
    let codigo = limpiar(q.get('c')) || (campana ? limpiar((prefijo ? prefijo + '-' : '') + campana) : '');
    if (codigo) {
      try {
        sessionStorage.setItem(CLAVE, codigo);
      } catch (e) {}
      return codigo;
    }
    try {
      codigo = limpiar(sessionStorage.getItem(CLAVE));
    } catch (e) {
      codigo = '';
    }
    return codigo || limpiar(porOmision);
  };

  // utm_* de la visita (letras y guion bajo en la clave; valor recortado). Se recuerdan durante la visita.
  const leerUtm = () => {
    const q = new URLSearchParams(window.location.search);
    const utm = {};
    q.forEach((valor, clave) => {
      if (/^utm_[a-z]{2,20}$/.test(clave) && valor) utm[clave] = String(valor).slice(0, 100);
    });
    if (Object.keys(utm).length) {
      try {
        sessionStorage.setItem(CLAVE_UTM, JSON.stringify(utm));
      } catch (e) {}
      return utm;
    }
    try {
      const guardado = JSON.parse(sessionStorage.getItem(CLAVE_UTM) || '{}');
      return guardado && typeof guardado === 'object' ? guardado : {};
    } catch (e) {
      return {};
    }
  };

  const conCodigo = (url, codigo, utm) => {
    if (!url) return '';
    try {
      const u = new URL(url, window.location.href);
      if (codigo) u.searchParams.set('c', codigo);
      // Solo a enlaces de otro sitio (el formulario del ERP); a Contacto de la tienda no se le agregan utm.
      // Los utm de la visita mandan; utm_source/utm_medium que falten se completan con los de la página.
      if (u.origin !== window.location.origin) {
        const marcas = Object.assign({}, UTM_OMISION, utm || {});
        Object.keys(marcas).forEach((clave) => {
          if (!u.searchParams.has(clave)) u.searchParams.set(clave, marcas[clave]);
        });
      }
      return u.toString();
    } catch (e) {
      return url;
    }
  };

  const enlaceWhatsapp = (numero, mensaje, codigo) => {
    const digitos = String(numero || '').replace(/\D/g, '');
    if (digitos.length < 10) return '';
    const texto = String(mensaje || '').trim() + (codigo ? ' · ' + codigo : '');
    return 'https://wa.me/' + digitos + '?text=' + encodeURIComponent(texto);
  };

  const enlaces = () => {
    const cfg = leerConfig();
    const codigo = leerCodigo(cfg.codigo);
    const utm = leerUtm();
    document.querySelectorAll('[data-mz-cta]').forEach((a) => {
      const tipo = a.dataset.mzCta;
      const registro = conCodigo(a.dataset.mzUrl || cfg.registro, codigo, utm);
      const wa = enlaceWhatsapp(a.dataset.mzNumero || cfg.whatsapp, a.dataset.mzMensaje || cfg.mensaje, codigo);
      if (tipo === 'whatsapp') {
        if (wa) a.href = wa;
        a.hidden = !wa;
      } else if (tipo === 'kit') {
        if (wa) {
          a.href = wa;
          a.target = '_blank';
          a.rel = 'noopener';
        } else if (registro) {
          a.href = registro;
        }
      } else if (registro) {
        a.href = registro;
      }
    });
  };

  const barraFija = () => {
    observadores.forEach((o) => o.disconnect());
    observadores = [];
    const barra = document.querySelector('[data-mz-cta-fija]');
    const hero = document.querySelector('[data-mz-hero]');
    if (!barra || !hero || !('IntersectionObserver' in window)) return;

    let heroArriba = false;
    const tapan = new Set();
    const pintar = () => barra.classList.toggle('mz-cta-fija--visible', heroArriba && tapan.size === 0);

    const oHero = new IntersectionObserver((entradas) => {
      entradas.forEach((e) => {
        heroArriba = !e.isIntersecting && e.boundingClientRect.top < 0;
      });
      pintar();
    });
    oHero.observe(hero);

    const oFinal = new IntersectionObserver((entradas) => {
      entradas.forEach((e) => (e.isIntersecting ? tapan.add(e.target) : tapan.delete(e.target)));
      pintar();
    });
    document.querySelectorAll('[data-mz-cta-final], .footer').forEach((el) => oFinal.observe(el));

    observadores = [oHero, oFinal];
    barra.hidden = false;
  };

  const live = () => {
    const d = new Date();
    const hoy = d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
    document.querySelectorAll('[data-mz-live-hasta]').forEach((el) => {
      const txt = String(el.dataset.mzLiveHasta || '').replace(/-/g, '');
      const hasta = parseInt(txt, 10);
      if (txt.length === 8 && hasta > 20000000 && hoy > hasta) el.hidden = true;
    });
  };

  const iniciar = () => {
    enlaces();
    barraFija();
    live();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  // Editor de temas: al recargar una sección, se vuelven a armar enlaces y observadores.
  document.addEventListener('shopify:section:load', iniciar);
})();
